// Tabela central de "tipo de ação" / área do processo, usada em TODO lugar do app que
// precisa dela: "Novo evento" (NewEventDialog.jsx), detalhe do processo
// (ProcessoDetail.jsx) e "Novo processo" (Processos.jsx). Antes do Lote novo
// (02/10/2026, pedido do Robson — incluir "Previdenciário" no cadastro de processo) essa
// tabela existia duplicada em 3 lugares diferentes (e espelhada no backend,
// server.py: PARTY_LABELS/CASE_AREA_LABEL) — risco real de ficarem desencontradas ao
// adicionar uma área nova. Agora é um só lugar no frontend; o backend continua com sua
// própria cópia (não compartilha código com o frontend), mas as DUAS precisam ser
// atualizadas juntas sempre que uma área for adicionada/removida aqui.
export const CASE_AREAS = [
  { value: "trabalhista", label: "Trabalhista" },
  { value: "civel", label: "Cível" },
  { value: "penal", label: "Penal" },
  { value: "previdenciario", label: "Previdenciário" },
  { value: "outro", label: "Outro" },
];

// Rótulo das partes conforme a área — trabalhista usa Reclamante/Reclamada, as demais
// usam Autor/Réu.
export const PARTY_LABELS = {
  trabalhista: ["Reclamante", "Reclamada"],
  civel: ["Autor", "Réu"],
  penal: ["Autor", "Réu"],
  previdenciario: ["Autor", "Réu"],
  outro: ["Autor", "Réu"],
};

// Áreas fixas (têm botão próprio) — qualquer outro valor cai em "outro" com o texto
// real guardado à parte (campo "_custom"), pra não perder o que foi digitado.
export const KNOWN_CASE_AREAS = ["trabalhista", "civel", "penal", "previdenciario"];
